import React, { Component, useMemo } from 'react';
import { FieldBase } from "easyui-core";
import { DragSource, DropTarget } from 'react-dnd'

import { Col } from 'antd';

const style: React.CSSProperties = {
    border: '1px dashed gray',
    padding: '0.5rem 1rem',
    marginBottom: '.5rem',
    backgroundColor: 'white',
    cursor: 'move',
}

const WfComponentTarget = {
    drop(props, monitor) {
        const item = monitor.getItem();
        console.log("item", item)
        if (item && item.index != undefined) {
            const dragIndex = item.index
            const hoverIndex = props.index;

            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return;
            }

            // Time to actually perform the action
            props.moveField(dragIndex, hoverIndex);

            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            monitor.getItem().index = hoverIndex;
        } else {
            const hoverIndex = props.index;
            props.addField(item, hoverIndex)
        }
    },
};
const WfComponentDropConnect = (connect, monitor, props) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
})


const WfComponentSource = {
    beginDrag(props) {
        // Return the data describing the dragged item
        const item = {
            id: props.key,
            index: props.index,
            field: props.field
        }
        return item
    },

    endDrag(props, monitor, component) {
        // debugger
        if (!monitor.didDrop()) {
            return
        }

        // When dropped on a compatible target, do something
        const item = monitor.getItem()
        const dropResult = monitor.getDropResult()
        //   CardActions.moveCardToList(item.id, dropResult.listId)
    },
}

/**
 * Specifies which props to inject into your component.
 */
function collect(connect, monitor) {
    return {
        // Call this function inside render()
        // to let React DnD handle the drag events:
        connectDragSource: connect.dragSource(),
        // You can ask the monitor about the current drag state:
        isDragging: monitor.isDragging(),
    }
}

class AntWfDragComponent extends Component<{
    component: Component,
    form: any,
    field: FieldBase<any>
    formLayout: string,
    moveField: any,
    addField: any
    index: number
}> {
    myRef: any;

    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        console.log("=======", props)
    }
    components = {

    };

    render() {
        const { isDragging, connectDragSource, connectDropTarget } = this.props as any
        const TagName: any = this.props.component
        const { getFieldDecorator } = this.props.form;
        const opacity = isDragging ? 0 : 1
        // const containerStyle = useMemo(() => ({ ...style, opacity }), [opacity])
        const containerStyle = { ...style, opacity }
        return connectDropTarget(connectDragSource(
            <div>
                <Col ref={this.myRef} span={this.props.field.span} style={containerStyle}>
                    <TagName form={this.props.form} field={this.props.field} formLayout={this.props.formLayout}></TagName>
                </Col>
            </div>
        ))
    }
}
// Export the wrapped version
export default DropTarget(["field", "component"], WfComponentTarget, WfComponentDropConnect)(DragSource("field", WfComponentSource, collect)(AntWfDragComponent))
// export default AntWfDragComponent;